import { Poptip, SidebarMenuItem } from "@optimizely/axiom";
import { ReactElement } from "react";
import { VirtualTeammate } from "../SVGIcons/VirtualTeammate";

/**
 * Icons that have no Font Awesome equivalent. Axiom renders `leftIcon` through its `Icon`
 * component, which accepts a React element in place of an icon name, so menu items can opt
 * into a bespoke SVG by using one of these keys as their `icon`.
 */
export const CUSTOM_MENU_ICONS: Record<string, ReactElement> = {
    "virtual-teammate": <VirtualTeammate />
};

type NavigationBarMenuItemProps = {
    className?: string;
    href: string;
    icon?: string;
    isActive?: boolean;
    onClick: (e?: React.MouseEvent) => void;
    showTooltip?: boolean;
    title: string;
    tooltip?: string;
};
export const NavigationBarMenuItem = ({
    className,
    href,
    icon,
    isActive,
    onClick,
    showTooltip,
    title,
    tooltip
}: NavigationBarMenuItemProps) => {
    const leftIcon = (icon ? CUSTOM_MENU_ICONS[icon] ?? icon : undefined) as any;

    const DefaultMenuItem = () => (
        <SidebarMenuItem
            className={className}
            key={title}
            title={title}
            leftIcon={leftIcon}
            href={href}
            onClick={onClick}
            isActive={isActive}
        />
    );
    if (showTooltip) {
        return (
            <Poptip isInline position="right" trigger="mouseenter" content={tooltip || title} className="">
                <DefaultMenuItem />
            </Poptip>
        );
    }
    return <DefaultMenuItem />;
};

NavigationBarMenuItem.displayName = "NavigationBarMenuItem";
